import { render, staticRenderFns } from "./SkinItemDysfunction.vue?vue&type=template&id=0c0d1244&scoped=true"
import script from "./SkinItemDysfunction.vue?vue&type=script&lang=js"
export * from "./SkinItemDysfunction.vue?vue&type=script&lang=js"
import style0 from "./SkinItemDysfunction.vue?vue&type=style&index=0&id=0c0d1244&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c0d1244",
  null
  
)

export default component.exports